import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FORMAT, formatTimestamp } from 'utils/Time';
import { Invoice } from 'services/checkout-service/models';
import { INVOICE_SUMMARY_TEST_IDS } from './const';

import styles from './styles.module.scss';

type InvoiceSummaryProps = Partial<Pick<Invoice, 'createdTime' | 'id' | 'notes'>>;

const InvoiceSummary: FC<InvoiceSummaryProps> = ({ createdTime, id, notes }) => {
  const { t } = useTranslation();

  const { creationDate, description, number } = INVOICE_SUMMARY_TEST_IDS;

  return (
    <article className={styles.invoiceSummary}>
      {createdTime &&
        <>
          <h2 className="h6">{t('invoiceSummary.creationDate')}</h2>
          <p data-testid={creationDate}>{formatTimestamp(createdTime, { format: FORMAT.DATE_LONG })}</p>
        </>
      }

      {id &&
        <>
          <h2 className="h6">{t('invoiceSummary.number')}</h2>
          <p data-testid={number}>{id}</p>
        </>
      }

      {notes &&
        <>
          <h2 className="h6">{t('invoiceSummary.description')}</h2>
          <p data-testid={description}>{notes}</p>
        </>
      }
    </article>
  );
};

export { InvoiceSummary };
